import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  margin-bottom: 1.5rem;
  width: 100%;

  &.hero-image-content {
    padding: 0;
  }

  &:first-child {
    margin-bottom: 0;
  }
  & > * {
    width: 100%;
  }

  &:last-child {
    padding-top: 1rem;
    border-top: 1px solid var(--gray100);
  }
`

export const BoxTextAligment = styled.div`
  display: grid;
  gap: 1rem;
`

export const DeliveryCashback = styled.div`
  display: flex;
  align-items: center;

  & > :first-child {
    display: flex;
    align-items: center;
    margin-right: 1rem;
    padding: 0.75rem;
    border-radius: 50%;
    background: var(--success100);
  }

  & > :last-child span {
    color: var(--success500);
  }
`

export const SecurityBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 2px solid var(--gray100);
  padding: 1rem;
  margin-top: 1rem;
  border-radius: 1rem;

  &:first-child {
    margin-top: 0;
  }
`

export const SecurityBoxHeader = styled.div`
  display: flex;
  margin-bottom: 0.5rem;
  align-items: center;
`

export const SecurityBoxIcon = styled.div`
  background-color: var(--primary100);
  display: flex;
  padding: 0.625rem;
  justify-content: center;
  align-items: center;
  border-radius: 0.5rem;
  margin-right: 0.5rem;
`
